import React from 'react';
import { Card, CardHeader, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import type { Person } from '../../../../types';
// ✅ REUSE existing tab component
import { DocumentsTab } from '../../../../components/profiles/tabs/DocumentsTab';

interface DocumentsPanelProps {
  personId: string;
  person: Person;
  showMetadata?: boolean;
  metadataFormat?: 'short' | 'long';
}

/**
 * DocumentsPanel - Wraps existing DocumentsTab with consistent styling
 *
 * This panel reuses 100% of the existing DocumentsTab component,
 * just adding a Card wrapper with consistent header styling.
 */
export const DocumentsPanel: React.FC<DocumentsPanelProps> = ({
  personId,
  person,
  showMetadata = false,
  metadataFormat = 'short'
}) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate(`/people/${personId}/documents`);
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader
        title="Documents"
        action={
          <Typography
            component="a"
            variant="caption"
            sx={{
              cursor: 'pointer',
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
            onClick={handleViewAll}
          >
            View All →
          </Typography>
        }
      />

      {/* ✅ Reuse existing DocumentsTab - zero changes needed */}
      <DocumentsTab person={person} />
    </Card>
  );
};
